import { Button, Icons, MarketingBanner } from '@cast/design-system';
import { useLocationWithOrgId } from 'hooks/useLocationWithOrgId';
import { useNavigate } from '@cast/infrastructure-organization';
import { ACTIVITY_PATHS } from '@cast/console-constants';

export const EVENT_LOG_PROMOTION_BANNER_ID = 'event-log-promotional-banner';

export const EventLogPromotionalBanner = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const auditLogLocation = useLocationWithOrgId(ACTIVITY_PATHS.activityEvents);

  return (
    <MarketingBanner
      title="Event log early access"
      message="Every meaningful event across your organization — clusters, nodes,
            commitments, configurations, and more — in a single timeline. Trace
            related events end-to-end and filter by domain, resource, or action
            to understand exactly what happened and why."
      onClose={onClose}
      action={
        <Button
          size="sm"
          endIcon={<Icons.ArrowRight />}
          onClick={() => auditLogLocation && navigate(auditLogLocation)}
          testId="view-event-log-btn"
        >
          Explore Event Log
        </Button>
      }
    />
  );
};
